import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useState } from 'react';
import s from './index.less';
import Link from '../../components/Link';
import AppQcode from '../../components/AppQcode';
export default function DecorationProcurement (props) {
    useStyles(s);

    const [param, setParam] = useState({
        goodsName: '',
        address: '',
        phone: '',
        email: '',
        company: '',
        shopName:'',
    });
    const [showAppQcode, setShowAppQcode] = useState(false);
    const goPage = (link) => {
        window.open('_self').location = link;
    }
    const paramInputChangeFun = (e, key) => {
        let obj = {};
        obj[key] = e.target.value
        setParam(Object.assign(param,obj))
    }
    return (
        <div className="page-toJoin">
            <div className='container'>
                <div className="bread-box-toJoin">
                    <div><Link to="/" target="_blank">首页</Link><span>&#65125;</span>我要入驻</div>
                    <div onClick={()=>{goPage('/entryInstructions?type=入驻说明')}}>入驻说明</div>
                </div>
                <div className="main-box">
                    <div className='process'>
                        <div className='settle-process'>
                            <div className='title'>商家入驻</div>
                            <div className='top-bg'>
                                <img src={require("../../images/common/toJoin-top.png")} />
                            </div>
                        </div>
                    </div>
                    <div className='welcome'>
                        <div className='form-wrap'>
                            <div className="welcome-desc-wrap">
                                <div className="divider"></div>
                                <div className="slogan">入驻本网 更多客户更多机遇</div>
                                <div className="sub-slogan">提交联系方式，我们会安排服务商尽快与您联系</div>
                            </div>
                            <div className='form-item-box'>
                                <div className='form'>
                                    <div className='form-item'>
                                    <div className='title'>所售商品</div>
                                    <input type="text"
                                        placeholder="请列举1-4个主营商品，逗号分隔"
                                        autoComplete="off"
                                        value={param.goodsName}
                                        onChange={(e) => paramInputChangeFun(e,'goodsName')}
                                         />
                                </div>
                                <div className='form-item'>
                                    <div className='title'>所在地</div>
                                    <input type="text"
                                        placeholder="请输入您的地址"
                                        autoComplete="off"
                                        value={param.address}
                                        onChange={(e) => paramInputChangeFun(e,'address')}
                                         />
                                </div>
                                <div className='form-item'>
                                    <div className='title'>手机号码</div>
                                    <input type="text"
                                        placeholder="请输入手机号码"
                                        autoComplete="off"
                                        value={param.phone}
                                        onChange={(e) => paramInputChangeFun(e,'phone')}
                                         />
                                </div>
                                
                                <div className='form-item'>
                                    <div className='title'>邮箱</div>
                                    <input type="text"
                                        placeholder="请输入邮箱"
                                        autoComplete="off"
                                        value={param.email}
                                        onChange={(e) => paramInputChangeFun(e,'email')}
                                         />
                                </div>
                                <div className='form-item'>
                                    <div className='title'>单位名称</div>
                                    <input type="text"
                                        placeholder="请输入单位名称"
                                        autoComplete="off"
                                        value={param.company}
                                        onChange={(e) => paramInputChangeFun(e,'company')}
                                         />
                                </div>
                                <div className='form-item'>
                                    <div className='title'>店铺名称</div>
                                    <input type="text"
                                        placeholder="请输入店铺名称"
                                        autoComplete="off"
                                        value={param.shopName}
                                        onChange={(e) => paramInputChangeFun(e,'shopName')}
                                         />
                                </div>
                                </div>
                                <div className='btn-container' onMouseEnter={()=>{setShowAppQcode(true)}} onMouseLeave={()=>{setShowAppQcode(false)}}>
                                    提交申请表
                                    <AppQcode visible={showAppQcode} position='right' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}